export const getBaseApiUrl = () => {
    if (window.location.hostname === "localhost") {
        return "https://localhost:5001/"
    } else if (window.location.hostname === "gaistoragetankbroker.dev.saleselement.net") {
        return "https://devstoragetankgaiapi.azurewebsites.net/"
    } else {
        return "https://prodgaistoragetankapi.azurewebsites.net/"
    }
}
